import { useFilterPenaltyScheduleContext } from "./filter-penalty-schedule.context";

export function FilterPenaltySchedule() {
  const { dateFilterElement, clearFiltersElement } =
    useFilterPenaltyScheduleContext();

  return (
    <div>
      <h2>Filters</h2>
      <p className="mb-4">
        Select the following filters you want to apply to the current table.
      </p>

      {dateFilterElement}
      {clearFiltersElement}
    </div>
  );
}